import { REMOVER_FILTRO_MDFE } from '../types'

export default function removerFiltroMdfe(filtro) {
  return {
    type: REMOVER_FILTRO_MDFE,
    payload: filtro
  }
}
